import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import componentLevel from './componentLevel';
import controller from './contribution-component.controller';
import directive from './contribution-component.directive';


export default angular.module('app.components.advisory.ecat.contributionComponent', [
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  constants,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  componentLevel,
])
  .directive('ecatContributionComponent', directive)
  .controller('ContributionComponentController', controller)
  .name;

console.log('app.components.advisory.ecat.contributionComponent created');
